export const topupTooltipText =
  "We'll monitor the card to make sure it stays at the target balance. You can adjust this setting in the Card Top-ups section.";

export const approverTooltipText =
  'The allocated approver(s) will be responsible for approving fund requests from employees.';

export const helpCenterUrl = 'https://byteorbit.atlassian.net/helpcenter/Paystashio/';
